var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
import React from "react";
import LoadingIcon from "./LoadingIcon";
import { getAppThemeName } from "../../../services/appTheme";
const Content = styled.span `
  opacity: ${props => (props.loading ? "0" : "1")};
  transition: color 100ms ease-in-out;
`;
const StyledButton = styled.button `
  position: relative;
  transition: background-color 200ms ease-in-out;
  text-align: ${props => (props.alignLeft ? "left" : "center")};
  border: none;
  height: ${props => (props.small ? "40px" : "50px")};
  padding-top: ${props => (props.small ? "8px" : "14px")};
  padding-bottom: ${props => (props.small ? "8px" : "14px")};
  font-family: ${props => props.theme.fontBase};
  padding-left: ${props => {
    if (props.icon && props.reversed && props.small) {
        return "16px";
    }
    if (props.icon && props.reversed) {
        return "24px";
    }
    if (props.icon && props.small) {
        return "36px";
    }
    if (props.icon) {
        return "48px";
    }
    if (props.small) {
        return "16px";
    }
    return "24px";
}};
  padding-right: ${props => {
    if (props.icon && props.reversed && props.small) {
        return "36px";
    }
    if (props.icon && props.reversed) {
        return "48px";
    }
    if (props.small && props.icon) {
        return "16px";
    }
    if (props.icon) {
        return "24px";
    }
    if (props.small) {
        return "16px";
    }
    return "24px";
}};
  color: ${props => {
    if (props.gray) {
        return props.theme.tertiary;
    }
    if (props.blueText) {
        return color.base.base;
    }
    return color.body.base;
}};
  border-radius: ${props => "6px"};
  font-weight: 500;
  font-size: ${props => {
    if (props.mediumFont) {
        return "16px";
    }
    if (props.largeFont) {
        return "16px";
    }
    return "15px";
}};
  cursor: pointer;
  width: ${props => (props.wide ? "100%" : "auto")};
  
  @media only screen and (min-width: 350px) {
    font-size: ${props => {
    if (props.largeFont) {
        return "17px";
    }
    return "15px";
}};
    }
  
 ${props => props.primary &&
    css `
     background-color: ${props => props.theme.primary};

     @media only screen and (min-width: 768px) {
       &:hover {
         background-color: ${props => props.theme.primaryHover};
       }
     }
   `}
 
${props => props.secondary &&
    css `
    background-color: ${props => props.theme.secondary};

    @media only screen and (min-width: 768px) {
      &:hover {
        background-color: ${props => props.theme.secondaryHover};
      }
    }
  `}
 
${props => props.tertiary &&
    css `
    background-color: ${props => props.theme.tertiary};

    @media only screen and (min-width: 768px) {
      &:hover {
        background-color: ${props => props.theme.tertiaryHover};
      }
    }
  `}

${props => props.red &&
    css `
    background-color: ${color.error.base};

    @media only screen and (min-width: 768px) {
      &:hover {
        background-color: ${color.error.hover};
      }
    }
  `}

${props => props.gray &&
    css `
    background-color: ${color.gray.light};

    @media only screen and (min-width: 768px) {
      &:hover {
        background-color: ${color.gray.base};
      }
    }
  `}
 
${props => props.green &&
    css `
    background-color: ${color.success.base};
  `}

  &:focus {
    outline: none;
  }
  
  ${props => props.quaternary &&
    css `
      background-color: ${props => props.theme.quaternary};

      @media only screen and (min-width: 768px) {
        &:hover {
          background-color: ${props => props.theme.quaternaryHover};
        }
      }
    `}

  ${props => props.white &&
    css `
      background-color: white;
      color: ${props => props.theme.textDark};

      svg {
        fill: ${props => props.theme.primary};
      }

      @media only screen and (min-width: 768px) {
        &:hover {
          background-color: white;
          color: ${props => props.theme.primary};
        }
      }
    `}

  &:focus {
    outline: none;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  
  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${props => {
    if (props.reversed && props.small) {
        return "auto";
    }
    if (props.reversed) {
        return "auto";
    }
    if (props.small) {
        return "10px";
    }
    return "15px";
}};
    right: ${props => {
    if (props.reversed && props.small) {
        return "10px";
    }
    if (props.reversed) {
        return "15px";
    }
    return "auto";
}};
  }
`;
const Button = (_a) => {
    var { loading = false, icon, children } = _a, restProps = __rest(_a, ["loading", "icon", "children"]);
    return (React.createElement(StyledButton, Object.assign({ icon: icon, disabled: restProps.disabled || loading, appTheme: getAppThemeName() }, restProps),
        React.createElement(React.Fragment, null,
            React.createElement(LoadingIcon, { loading: loading ? 1 : 0 }),
            React.createElement(Content, { loading: loading ? 1 : 0 },
                icon,
                children))));
};
export default Button;
